import React from 'react'
import { modules } from '../../../modules'
import ProtectedRoute from '../../internal/ProtectedRoute'
import useModuleMenu from '../../hooks/useModuleMenu'
import Reconciliation from './Reconciliation'

const ReconciliationRoutes = ({ authorities }) => {
  if (authorities?.length) {
    const menuData = useModuleMenu(modules.reconciliationApp, authorities)

    if (menuData?.routeItems) {
      return menuData.routeItems.map(({ authority, key, link }) => {
        return (
          <ProtectedRoute
            authority={authority}
            key={key}
            path={link}
            exact
            page={<Reconciliation />}
          />
        )
      })
    }
  }

  return []
}

export default ReconciliationRoutes
